export enum CashflowTypeEnum {
    Injection = "INJECTION",
    Distribution = "DISTRIBUTION"
}

export const isCashflowTypeEnum = (value: string): value is CashflowTypeEnum => Object.values(CashflowTypeEnum).includes(value as CashflowTypeEnum);
